import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import MiscPageLayout from "../../components/FullPageLayout/MiscPageLayout";
import TermsAndConditionsContent from "./TermsAndConditionsContent";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const { english, spanish } = {
  english: "en",
  spanish: "es"
};

const TermsAndConditions = () => {
  const [language, setLanguage] = useState("en");
  const { t } = useTranslation();
  const showUpdatedTocMessage = useSelector(state => {
    return (
      state.userState.user.tcAccepted &&
      state.userState.user.tcLanguage === language
    );
  });

  const children = (
    <Box display="flex" flexDirection="column" mt={3}>
      <Box display="flex" mb={3}>
        <Button color="primary" onClick={() => setLanguage(english)}>
          {t("language.en")}
        </Button>
        <Button color="primary" onClick={() => setLanguage(spanish)}>
          {t("language.es")}
        </Button>
      </Box>
      <TermsAndConditionsContent
        language={language}
      ></TermsAndConditionsContent>
    </Box>
  );

  return (
    <MiscPageLayout
      title={<Typography variant="h1">{t("toc.title")}</Typography>}
      subtitle={
        showUpdatedTocMessage ? (
          <Box pt={2}>
            <Typography variant="h4">{t("toc.updatedMsg")}</Typography>
          </Box>
        ) : null
      }
      children={children}
    ></MiscPageLayout>
  );
};

export default TermsAndConditions;
